import { Person } from "@/Common/Models/Person/Person";

class AdditionalInformationFormData {
    public origin: string = "";
    public requestNo: string = "";
    public prescribers: Person[] = [];
    public cc: Person[] = [];
    public resultSentDateTime: Date;

    public isValid(): boolean {
        return this.prescribers.length === 1;
    }
}

export { AdditionalInformationFormData };
